import { FC } from 'react';
import styled from 'styled-components';

const Modal: FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Modal;

const Wrapper = styled.section`
  position: fixed;
  z-index: 2;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #4e4e7550;
  display: flex;
  justify-content: center;
  align-items: center;
`;
